import { Theme } from '#app/theme/index.js';
import { parseMediaQueryForMatchMedia } from '#app/utilities/parseMediaQueryForMatchMedia.js';
import { useMediaQuery } from '@contra/react-hooks/useMediaQuery';
import { useTheme } from 'styled-components';

export const useBreakpoint = (
  breakpoint: keyof Pick<Theme['mediaQueries'], 'lg' | 'md' | 'sm' | 'xl'>,
) => {
  const theme = useTheme();
  return useMediaQuery(
    parseMediaQueryForMatchMedia(theme.mediaQueries[breakpoint]),
  );
};
